import React, { useEffect, useState } from 'react';
import { Timer } from 'lucide-react';
export function StickyAlertBar() {
  const [timeLeft, setTimeLeft] = useState(300); // 5 minutes in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <div className="fixed top-0 left-0 w-full z-50 bg-brand-red text-white py-2 px-4 shadow-md" data-id="element-208">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 text-center text-sm sm:text-base font-medium" data-id="element-209">
        <span className="flex items-center gap-2" data-id="element-210">
          <span className="animate-pulse" data-id="element-211">🔥</span>
          OFERTA DE LANZAMIENTO COMBO 3x1: SOLO HOY
        </span>
        <span className="flex items-center gap-1 bg-white/20 px-2 py-0.5 rounded-md font-bold tracking-wider" data-id="element-212">
          <Timer className="w-4 h-4" data-id="element-213" />[{formattedTime}]
        </span>
      </div>
    </div>;
}